import type { SchemaInput } from '../shared/schema-input.js';
import { normalizeStrokeOpacity, normalizeUnitOpacity } from '../shared/stroke-opacity.js';
import type { Stroke } from '../types/app.js';
export type LineStyle = 'solid' | 'dashed';

export function normalizeLineStyle(value: SchemaInput): LineStyle {
  return value === 'dashed' ? value : 'solid';
}

export function getStrokeOpacity(stroke: { opacity?: unknown }): number {
  return normalizeStrokeOpacity(stroke.opacity);
}

export function getPolygonOutlineOpacity(stroke: Pick<Stroke, 'outlineOpacity'>): number {
  return normalizeUnitOpacity(stroke.outlineOpacity);
}

export function getPolygonFillOpacity(stroke: Pick<Stroke, 'fillOpacity'>): number {
  return stroke.fillOpacity === undefined ? 0.25 : normalizeUnitOpacity(stroke.fillOpacity);
}

export function getStrokeLineStyle(stroke: { lineStyle?: unknown }): LineStyle {
  return normalizeLineStyle(stroke.lineStyle);
}
